/** Hides a page from production and redirects to index page */
export default function ({ redirect, $config }) {
    if ($config.isProduction) {
        redirect({ name: "index" })
    }
}
